module.exports = __webpack_public_path__ + "media/images/background_solutions-800w-734736f3.jpg";